import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Field, reduxForm} from 'redux-form'
import {Badge, Col, Form, Modal, Row} from "react-bootstrap"
import {CheckboxField, MultiCheckboxField, SelectField, TextareaField, TextField} from '../form/form'
import {connect} from "react-redux";
import {showMessage} from '../../actions';
import {defaultState} from '../../reducers/entity';
import {BaseStatus, EventType, EventTypeLabel} from "../../utils/enums";
import {createOptions, Date, Enums, resolveApiResult, validateChipNumber} from "../../utils";
import {showModal} from "../../actions/modal";
import {loadEvent, saveEvent} from "../../actions/events";
import {handleItemSave, ItemContext, onItemSaveSuccess, renderItemFormButtons, renderItemFormFiles} from "../dog/helpers";
import {renderDateField} from "../form/DateField";
import {loadFiles, saveFile} from "../../actions/files";
import {formatEventDescription, getEventExpirationClassName} from "../../utils/format";

const validate = (values) => {
	const errors = {};
	if (!values.eventType) {
		errors.eventType = 'Zvolte prosím typ';
	} else {
		switch (values.eventType) {
			case EventType.CH:
				validateChipNumber(values, 'chipNumber', errors);
				break;

			case EventType.VA:
				if (!values.vaccineId) {
					errors.vaccineId = 'Vyberte prosím vakcínu';
				}
				break;

			case EventType.PE:
			case EventType.PI:
				if (!values.methodId) {
					errors.methodId = 'Vyberte prosím metodu';
				}
				if (!values.eventDesc) {
					errors.eventDesc = 'Zadejte prosím přípravek';
				}
				break;

			case EventType.CA:
				break;

			case EventType.OT:
				if (!values.eventDesc) {
					errors.eventDesc = 'Uveďte prosím popis';
				}
				break;

			default:
		}
	}

	return errors
}

const textual = (item) => {
	return EventTypeLabel[item.eventType] + ' ' + Date.formatDate(item.eventDate) + ' (ID ' + item.eventId + ')';
}

export const createEventInitialValues = (eventId, dogId, session) => {
	return eventId
		? {dogId, eventId}
		: {
			dogId,
			eventDate: Date.format(Date.today(), Date.ISO_DATE),
			eventBy: session.user.userId
		};
}

class EventForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			eventType: null,
			expireFrom: null,
			expireTo: null,
			currentFiles: [],
		}

		this.handleSave = this.handleSave.bind(this);

		this.ctx = {
			itemTag: 'Úkon',
			itemKeyName: 'eventId',
			saveItem: props.saveEvent,
			saveFile: props.saveFile,
			showMessage: props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, props)
		}
	}

	componentWillMount() {
		this.loadEvent(this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.event.eventId !== this.props.event.eventId) {
			this.loadEvent(nextProps);
		}
	}

	loadEvent(props) {
		const {event} = props;
		if (event.eventId) {
			this.props.loadEvent(event.eventId).then((json) => {
				if (resolveApiResult(json)) {
					this.syncEnumsAndState(json.response.data);
				}
			});
			this.props.loadFiles({eventId: event.eventId, statuses: [BaseStatus.ACTIVE]}).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({currentFiles: json.response.data});
				}
			});
		} else {
			this.syncEnumsAndState(event);
		}
	}

	syncEnumsAndState(event) {
		this.setState({
			eventType: event == null ? null : event.eventType,
			eventAt: event == null ? null : event.eventAt,
			expireFrom: event == null ? null : event.expireFrom,
			expireTo: event == null ? null : event.expireTo,
		});
	}

	handleSave(values) {
		const v = {...values};
		if (v.eventType !== EventType.CH) {
			v.chipNumber = null;
		}
		if (v.eventType !== EventType.VA) {
			v.vaccineId = null;
		}
		if (v.eventType !== EventType.PE && v.eventType !== EventType.PI && v.eventType !== EventType.VA && v.eventType !== EventType.CH) {
			v.expireFrom = null;
			v.expireTo = null;
			v.expireStatus = null;
			v.expireApplyIds = null;
		}
		if (v.eventType !== EventType.PE && v.eventType !== EventType.PI) {
			v.methodId = null;
			v.pillsAmount = null;
		}
		return handleItemSave(this.ctx, v);
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			{(!item || isFetchingItem) ? null : this.renderForm()}
		</Modal>
	}

	renderForm() {
		const {entity: {item}, initialValues, handleSubmit, dog, eventsPage, enums} = this.props;
		const {eventType, expireFrom, expireTo} = this.state;

		const rows = [];
		let hasNote = false;
		let hasDoctor = false;
		let expireLabel = null;

		switch (eventType) {
			case EventType.CH: // chip
				rows.push([
					<Row key={'chip'}>
						<Col sm={6}>
							<Field label={'Čip'} name={"chipNumber"} component={TextField} maxLength={15}/>
						</Col>
					</Row>
				]);
				expireLabel = 'Expirace';
				hasDoctor = true;
				break;

			case EventType.VA: // vaccination
				rows.push([
					<Row key={'vaccine'}>
						<Col sm={12}>
							<Field label={'Vakcína'} name={'vaccineId'} type='text' component={SelectField}
								options={Enums.createEnumItems(enums, Enums.getKey("vaccine"), true)}
								clearable={true} sizes={[2, 10]}/>
						</Col>
					</Row>,
					// <Row key={'eventDesc'}>
					// 	<Col sm={12}>
					// 		<Field label={'Proti'} name={"eventDesc"} component={TextField} maxLength={100} sizes={[2, 10]}/>
					// 	</Col>
					// </Row>,
				]);
				expireLabel = 'Přeočk.';
				hasNote = true;
				hasDoctor = true;
				break;

			case EventType.PE: // external par.
			case EventType.PI: // internal par.
				rows.push([
					<Row key={'method'}>
						<Col sm={6}>
							<Field label={'Forma'} name={'methodId'} type='text' component={SelectField}
								options={Enums.createEnumItems(enums, Enums.getKey(eventType === EventType.PE ? 'methodExt' : 'methodInt'), true)}
								clearable={true}/>
						</Col>
					</Row>,
					<Row key={'amount'}>
						<Col sm={6}>
							<Field label={'Název'} name={"eventDesc"} component={TextField} maxLength={100}/>
						</Col>
						<Col sm={6}>
							<Field label={'Množství'} name={"pillsAmount"} component={TextField} maxLength={100}/>
						</Col>
					</Row>,
				]);
				expireLabel = 'Obnovit';
				break;

			case EventType.CA: // castration
				rows.push([
					<Row key={'eventDesc'}>
						<Col sm={12}>
							<Field label={'Způsob'} name={"eventDesc"} component={TextField} maxLength={100} sizes={[2, 10]}/>
						</Col>
					</Row>,
				]);
				hasNote = true;
				hasDoctor = true;
				break;

			case EventType.OT: // other
				rows.push([
					<Row key={'eventDesc'}>
						<Col sm={12}>
							<Field label={'Popis'} name={"eventDesc"} component={TextField} maxLength={100} sizes={[2, 10]}/>
						</Col>
					</Row>,
				]);
				hasNote = true;
				break;

			default:
				break;
		}

		if (expireLabel) {
			const expireApplyOptions = [];
			if (eventsPage && eventsPage.items && eventsPage.items.length) {
				eventsPage.items.forEach((e) => {
					if (e.eventId === initialValues.eventId) {
						return;
					}
					if (e.eventType === eventType
						&& e.expireStatus !== 'APPLIED'
						&& (e.expireFrom || e.expireTo)) {
						expireApplyOptions.push({
							value: e.eventId,
							label: <div>{Date.formatDate(e.eventDate)} {formatEventDescription(e, enums)}</div>,
							className: getEventExpirationClassName(e)
						});
					}
				})
			}

			rows.push([
				<Row key={'expire'}>
					<Col sm={6}>
						{renderDateField({
							label: expireLabel + ' od', name: "expireFrom", maxDate: expireTo, clearable: true, onChangeHook: (expireFrom) => {
								this.setState({expireFrom})
							}
						})}
					</Col>
					<Col sm={6}>
						{renderDateField({
							label: expireLabel + ' do', name: "expireTo", minDate: expireFrom, clearable: true, onChangeHook: (expireTo) => {
								this.setState({expireTo})
							}
						})}
					</Col>
				</Row>,
				initialValues.eventId
					? <Row key={'expireStatus'}>
						<Col sm={10} smOffset={2} style={{marginTop: '-15px', marginBottom: '5px'}}>
							<Field label={'Obnova proběhla'} name={"expireStatus"} component={CheckboxField}/>
						</Col>
					</Row>
					: (expireApplyOptions.length > 0 && <Row key={'expireApply'}>
						<Col sm={12}>
							<Field label={'Označit jako obnovené'} name={'expireApplyIds'} component={MultiCheckboxField} options={expireApplyOptions} vertical={true} sizes={[2, 10]}/>
						</Col>
					</Row>)
			]);
		}

		if (hasNote) {
			rows.push(<Row key={'note'}>
				<Col sm={12}>
					<Field label={'Poznámka'} name={"eventNote"} type="text" component={TextareaField}/>
				</Col>
			</Row>)
		}

		if (hasDoctor) {
			rows.push(<Row key={'doctor'}>
				<Col sm={6}>
					<Field label={'Lékař'} name={'eventDoctor'} type="text" component={TextField} maxLength={100}/>
				</Col>
			</Row>)
		}


		rows.push(<Row key={'eventBy'}>
			<Col sm={6}>
				<Field label={hasDoctor ? 'Zapsal' : 'Provedl'}
					name={"eventBy"} component={SelectField} options={Enums.createEnumItems(enums, 'user')}/>
			</Col>
			<Col sm={6}>
				{renderDateField({
					label: 'Datum', title: 'Datum provedení úkonu', name: "eventDate", maxDate: Date.today(),
					clearable: true
				})}
			</Col>
		</Row>);

		let title;
		if (initialValues.eventId) {
			title = <span>Úprava úkonu <Badge pullRight>{initialValues.eventId}</Badge></span>;
		} else {
			title = 'Nový úkon';
		}
		if (dog && dog.name) {
			title = <span>{dog.name} - {title}</span>;
		}

		return (<Form horizontal onSubmit={handleSubmit(this.handleSave)} className="detail">
			<Modal.Header>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row>
					<Col sm={6}>
						<Field label={'Typ'} name={"eventType"} component={SelectField} options={createOptions(EventTypeLabel)}
							onChangeHook={(eventType) => this.setState({eventType})}
						/>
					</Col>
				</Row>
				{eventType && rows}
				{eventType && renderItemFormFiles(this.state.currentFiles)}
			</Modal.Body>

			<Modal.Footer>
				{renderItemFormButtons(this.ctx, item, this.props)}
			</Modal.Footer>
		</Form>);
	}
}

EventForm = reduxForm({
	enableReinitialize: true,
	form: 'event',
	validate
})(EventForm);


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {events, dogs},
		pagination,
		enums,
		session
	} = state;

	const form = state.form['event'];
	const {event} = ownProps;

	const dog = ((dogs[event.dogId] ? dogs[event.dogId].item : event.dog) || event.dog) || {};

	const entity = event.eventId && events[event.eventId]
		? events[event.eventId]
		: {
			...defaultState,
			item: (form || {}).initial || (event.eventId ? null : {...event})
		};

	const eventsPage = pagination.events[0] || defaultState;

	return {
		entity,
		initialValues: entity.item,
		dog: dog,
		eventsPage,
		enums,
		session
	}
}

EventForm.propTypes = {
	dog: PropTypes.object,
	event: PropTypes.object.isRequired,
	loadEvent: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	saveEvent: PropTypes.func.isRequired,
	saveFile: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadEvent,
	loadFiles,
	saveEvent,
	saveFile,
	showMessage,
	showModal
})(EventForm)



// WEBPACK FOOTER //
// ./src/components/event/EventForm.js